import { format } from '@e3dc-react/shell/Libs/date'
import React from 'react'
import { FetchingState, LoadingState } from 'src/Libs/chart-kit/shared/utils/chartModel'
import { Box, Typography } from '@mui/material'
import { isUndefined } from 'lodash'

interface Props {
  loadingState: LoadingState
}

const ProgressDetails: React.FC<Props> = ({ loadingState }) => {
  const isCompleted = loadingState.state === FetchingState.Completed
  const fetchedMonthsIsUndefined = isUndefined(loadingState.fetchedMonths)
  const monthAmountToFetchIsUndefined = isUndefined(loadingState.monthAmountToFetch)

  if (isCompleted || fetchedMonthsIsUndefined || monthAmountToFetchIsUndefined) return null

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      <Typography>
        {loadingState.fetchedMonths! + 1}/{loadingState.monthAmountToFetch}
      </Typography>
      {loadingState.currentMonthTs !== undefined && <Typography>{format(loadingState.currentMonthTs, 'MMM yyyy')}</Typography>}
    </Box>
  )
}

export default ProgressDetails
